import { useEffect, useState } from "react";
import Spinner from "../components/Spinner/Spinner";
import { useUser } from "./provider/UserAuthProvider";
import AlertDialog from "../components/Dialog/AlertDialog";
import { useNavigate } from "react-router-dom";

function LoginCallbackPage() {
  const user = useUser();
  const [showLoginFailedDialog, setShowLoginFailedDialog] = useState({ show: false, message: "" });
  const [code, setCode] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const searchParams = new URLSearchParams(window.location.search);
    const code = searchParams.get("code");
    setCode(code);
  }, []);

  useEffect(() => {
    if (!code) {
      // window.location.replace("/");
      return;
    }

    console.log("LoginCallbackPage code:", code);

    async function loginWithCode() {
      try {
        await user.loginWechatWitCode(code);
        // Redirect to home page after successful login
        // window.location.replace("/");
        navigate("/");
      } catch (error) {
        setShowLoginFailedDialog({ show: true, message: error.message || "" });
        console.error("Login failed:", error);
      }
    }

    loginWithCode();
  }, [code]);

  return (
    <>
      {showLoginFailedDialog.show && (
        <AlertDialog
          title={"登录失败"}
          text={showLoginFailedDialog.message}
          positiveText={"返回"}
          onPositive={() => {
            navigate("/");
            setShowLoginFailedDialog(false);
          }}
        />
      )}
      <div style={{ display: "flex", justifyContent: "center", alignItems: "center", minHeight: "100vh" }}>
        <Spinner />
      </div>
    </>
  );
}

export default LoginCallbackPage;
